<div class="btn-close-wrapper">
  <button *ngIf="showNavigationBtn" mat-button (click)="goToGoogleMaps()">
    <mat-icon class="material-icons-outlined" fontIcon="directions"></mat-icon>
    {{ 'NAVIGATE_TO' | translate }}
  </button>
  <button
    tabindex="-1"
    mat-icon-button
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="wrapper">
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="header">
          {{ 'ATTRIBUTES' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngFor="let item of data.attributes | keyvalue">
        <attribute-item [item]="item"></attribute-item>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="data.tasks.length" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="header">
          {{ 'TASKS.LABEL' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="task-item" *ngFor="let task of data.tasks" mat-button>
        <div>
          <b>{{ task.name }}</b><br>
          {{ ('TASKS.STATUS.' + task.status) | translate }}<br>
          {{ 'DEFECTS.LABEL' | translate}}: {{ task.failureCount || 0 }}
        </div>
        <div>
          <ul>
            <li *ngFor="let user of task.assignees"> {{ getUserLabel(user) }}</li>
          </ul>
        </div>
        <button *ngIf="!data.isDynamicControl" mat-icon-button (click)="goToTask(task.id)" [matTooltip]="'FORM' | translate">
          <mat-icon>launch</mat-icon>
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>



